export const getProfileRootSelector = (state) => state.profile;
export const getProfileCheckedSelector = (state) => getProfileRootSelector(state).checked;
